import { updateDepartmentRequest } from "../../data/departmentApi";
import { validateDepartmentPayload } from "../validator/validateDepartmentPayload";

export async function updateDepartmentUseCase(payload) {
  const error = validateDepartmentPayload(payload);

  if (error) {
    throw new Error(error);
  }

  if (!payload?.id) {
    throw new Error("El id es obligatorio.");
  }

  return await updateDepartmentRequest(payload);
}
